import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { addressModalRecoil } from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import DaumPostcode from 'react-daum-postcode';

interface AddressModalProps {
  onAddressChange: (value: string) => void;
}

const AddressModal = ({ onAddressChange }: AddressModalProps) => {
  const [addressModalState, setAddressModalState] =
    useRecoilState(addressModalRecoil);

  const handleAddressSubmit = (data: any) => {
    onAddressChange(data);
    setAddressModalState(false);
  };

  return (
    <>
      <CS.ModalBg>
        <Modal>
          <div className="top-box">
            <button
              className="x-btn img-box"
              onClick={() => setAddressModalState(false)}
            >
              <img src="/img/ico_x_444.svg" alt="" />
            </button>
          </div>
          <DaumPostcode onComplete={handleAddressSubmit} autoClose={true} />
        </Modal>
      </CS.ModalBg>
    </>
  );
};

export default AddressModal;

const Modal = styled.div`
  width: 500px !important;
  height: 600px !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  > .top-box {
    width: 100%;
    background: #fff;
    height: 50px;
    position: relative;
    > .x-btn {
      position: absolute;
      width: 16px;
      top: 50%;
      right: 16px;
      transform: translateY(-50%);
    }
  }
  > div:nth-child(2) {
    height: 100% !important;
  }
`;
